

import "./FacultySection.css";
import CommonHeading from "../../common-component/common-heading/CommonHeading";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const faculty = [
  {
    image: "/assets/images/online_mba/facultysection/Aarushi_Nagar.webp",
  },
  {
    image: "/assets/images/online_mba/facultysection/Prathmi_Thosan.webp",
  },
  {
    image: "/assets/images/online_mba/facultysection/Preksha_Mutha.webp",
  },
  {
    image: "/assets/images/online_mba/facultysection/Raj_Bakhru.webp",
  },
  {
    image: "/assets/images/online_mba/facultysection/Rohit_Kapoorr.webp",
  },
  {
    image: "/assets/images/online_mba/facultysection/Siddharth_Fernandes.webp",
  },
   {
    image: "/assets/images/online_mba/facultysection/Varun_Dave.webp",
  },
];

export default function FacultySection() {
  return (
    <section className="faculty_section">
      <div className="container">
        <div className="faculty_wrapper">
          <div className="faculty_content">
            <CommonHeading
              subTitle={
                <>
                  The Next Success Story
                  <br />
                  Could Be Yours
                </>
              }
              description="From ambitious learners to sought-after professionals, our graduates are building successful careers with some of the world's leading organisations."
            />
          </div>

          <div className="faculty_slider">
            <Swiper
              modules={[Autoplay]}
              loop
              speed={700}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              slidesPerView={4}
              spaceBetween={20}
              breakpoints={{
                320: {
                  slidesPerView: 1.4,
                  spaceBetween: 15,
                },
                768: {
                  slidesPerView: 2.5,
                  spaceBetween: 20,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
            >
              {faculty.map((item, index) => (
                <SwiperSlide key={index}>
                  <div
                    className={`faculty_card ${
                      index % 2 === 0 ? "rotate_left" : "rotate_right"
                    }`}
                  >
                    <img src={item.image} alt={item.name} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
